"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactiveLayout = exports.initPlugin = void 0;
const vue_1 = require("vue");
const ant_design_vue_1 = require("ant-design-vue");
const complex_plugin_1 = require("complex-plugin");
const complex_utils_1 = require("complex-utils");
// 初始化环境参数
(0, complex_utils_1.setEnvMode)(process.env.VUE_APP_ENV, 'data');
(0, complex_utils_1.setEnvMode)(process.env.VUE_APP_ENV, 'real');
const reactiveLayoutObject = (0, vue_1.reactive)(complex_plugin_1.layout);
const initPlugin = function (app, layout) {
    (0, complex_plugin_1.install)({
        layout: false,
        notice: {
            showMsg: function (content, type = 'info', title = '通知', duration = 3) {
                this.setMsg({
                    message: title,
                    description: content,
                    duration: duration
                }, type);
            },
            setMsg: function (option, type = 'info') {
                if (ant_design_vue_1.notification[type]) {
                    ant_design_vue_1.notification[type](option);
                }
                else {
                    // eslint-disable-next-line no-console
                    console.error('notification type is not defined, type reset open');
                    ant_design_vue_1.notification.open(option);
                }
            },
            alert: function (content, title = '警告', next, okText = '确认') {
                this.setModal({
                    title: title,
                    content: content,
                    okText: okText,
                    onOk: function () {
                        if (next) {
                            next('ok');
                        }
                    }
                }, 'error');
            },
            confirm: function (content, title = '警告', next, okText = '确认', cancelText = '取消') {
                this.setModal({
                    title: title,
                    content: content,
                    okText: okText,
                    cancelText: cancelText,
                    onCancel: function () {
                        if (next) {
                            next('cancel');
                        }
                    },
                    onOk: function () {
                        if (next) {
                            next('ok');
                        }
                    }
                }, 'confirm');
            },
            setModal: function (option, type = 'info') {
                if (ant_design_vue_1.Modal[type]) {
                    return ant_design_vue_1.Modal[type](option);
                }
                else {
                    // eslint-disable-next-line no-console
                    console.error('modal type is not defined, type reset info');
                    return ant_design_vue_1.Modal.info(option);
                }
            }
        }
    });
    if (layout && layout !== true) {
        layout(reactiveLayoutObject);
    }
    if ((0, complex_utils_1.getEnv)('real') === 'development' && localGlobalData.env.change) {
        // 真实环境为开发环境，且需要更改环境时
        (0, complex_utils_1.setEnv)(localGlobalData.env.data.env, 'data');
        (0, complex_utils_1.setEnvMode)(localGlobalData.env.data.mod, 'data');
        if ((0, complex_utils_1.getEnv)() === 'production') {
            // 更改的环境为线上环境，则弹出提示
            const currentEnvMode = (0, complex_utils_1.getEnvMode)();
            if (currentEnvMode === 'test') {
                complex_plugin_1.notice.showMsg('当前环境为测试环境！', 'info', '警告', 5);
            }
            else if (currentEnvMode === 'prod') {
                complex_plugin_1.notice.showMsg('当前环境为生产环境，请谨慎操作！', 'warn', '警告', 10);
            }
        }
    }
    reactiveLayoutObject.initBody();
    return app;
};
exports.initPlugin = initPlugin;
exports.reactiveLayout = reactiveLayoutObject;
